import { Checkbox, Radio, Typography } from "antd";
import {
  PAVE_STONE_REMOVAL_PRICE_NOK,
  STONE_REMOVAL_PRICE_NOK,
  type StoneRequestMode,
} from "@gull/shared";
import type { StoneHandlingDraft } from "./hooks/useStoneHandling";
import type { DraftItem } from "./types";

const { Paragraph } = Typography;

export interface StonesStepProps {
  items: DraftItem[];
  stones: StoneHandlingDraft;
}

export default function StonesStep({ items, stones }: StonesStepProps) {
  return (
    <section className="sendin-panel">
      <h2>Stener, perler eller ur</h2>
      <Paragraph>
        Om dine smykker inneholder noe du ønsker å beholde, som stener, perler og ur kan dette
        fjernes skånsomt av våre gullsmeder mot et tillegg. Estimert tid på dette er 3-4 uker.
      </Paragraph>

      <Radio.Group
        value={stones.mode}
        onChange={(event) => stones.setMode(event.target.value as StoneRequestMode)}
        className="sendin-stone-options"
      >
        <Radio value="NONE_OR_KEEP">
          Gjenstandene har ingen eller jeg ønsker ikke å fjerne noen stener, perler eller ur.
        </Radio>
        <Radio value="SPECIFIC">
          {`Jeg ønsker å spesifisere hvilke gjenstander som skal få skånsomt fjernet stener, ur eller perler av gullsmed (dette har et tillegg på ${STONE_REMOVAL_PRICE_NOK} kr pr gjenstand, eller ${PAVE_STONE_REMOVAL_PRICE_NOK} kr om det gjelder mange stener (pavé)).`}
        </Radio>
      </Radio.Group>

      {stones.mode === "SPECIFIC" ? (
        <Checkbox.Group
          value={stones.selectedItemIndexes}
          onChange={(value) => stones.setSelectedItemIndexes(value as number[])}
          className="sendin-specific-items"
        >
          {items.map((item, index) => (
            <Checkbox value={index} key={index}>
              {item.description.trim() || `Gjenstand ${index + 1}`}
            </Checkbox>
          ))}
        </Checkbox.Group>
      ) : null}
    </section>
  );
}
